import React from 'react'
import Modal from 'react-bootstrap/Modal'

import Backend from "../../../../utils/Backend"
import Notify from "../../../../utils/Notify"
import Select from "../../common/CustomSelect";

const YES_NO_OPTIONS = [
  {
    label: "Yes",
    value: true
  },
  {
    label: "No",
    value: false
  },
]

export default class BoipaConnectProcessor extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      ...this._getState(props)
    }

  }

  componentWillReceiveProps(nextProps){
    this.setState(this._getState(nextProps))
  }

  _getState(props){
    return {
      ...props,
      data: props.data || {
        app_id: null,
        app_key: null,
        merchant_id: null,
        account_name: null,
        sub_marchant: null,
      },
    }
  }

  _isFormValid(){
    let { data } = this.state

    let {
      app_id,
      app_key,
      merchant_id,
      account_name,
      sub_merchant,
    } = data

    let error = null
    if(sub_merchant == null) {
      error = "Sub Merchant must be specified"
    }
    else if(sub_merchant === true){
      if(app_id){
        error = "App ID cannot be provided when sub merchant is true"
      }
      else if(app_key){
        error = "App Key cannot be provided when sub merchant is true"
      }
    }
    else if(!account_name){
      error = "Account Name must be specified"
    }
    else if(!app_id){
      error = "App ID must be specified"
    }
    else if(!app_key){
      error = "App Key must be specified"
    }
    else if(!merchant_id){
      error = "Merchant ID must be specified"
    }

    if(error){
      Notify.error(error)
      return false
    }

    return true
  }

  _connect(){
    let {
      company,
      data,
    } = this.state

    if(!this._isFormValid()){
      return
    }

    this.setState({ loading: true })
    Backend.connectToGlobalPayments(company, data)
    .then(data => {
      Notify.success("Connected Successfully")
      this.setState({ loading: false })
      this.props.onUpdated()
    })
    .catch(error => {
      this.setState({ loading: false })
      Notify.error(error.message)
    })
  }


  render(){
    let {
      data,
      loading
    } = this.state

    return (
      <>
        <Modal.Body>
          <div className="form-group row">
            <label className="col-3 col-form-label">Sub Merchant*</label>
            <div className="col-9">
              <Select
                value={YES_NO_OPTIONS.find(option => option.value === data.sub_merchant)}
                className="form-control h-auto border-0 form-control-solid c-selectbox"
                name="sub_merchant"
                placeholder="Please Select A Value"
                onChange={option => {
                  data.sub_merchant = option.value
                  this.setState({data})
                }}
                options={YES_NO_OPTIONS}
              />
            </div>
          </div>

          <div className="form-group row">
            <label className="col-3 col-form-label">Account Name{data.sub_merchant === false ? "*" : ""}</label>
            <div className="col-9">
              <input
                className="form-control form-control-solid"
                type="text"
                value={data.account_name}
                onChange={e => {
                  data.account_name = e.target.value || null
                  this.setState({data})
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-3 col-form-label">App ID{data.sub_merchant === false ? "*" : ""}</label>
            <div className="col-9">
              <input
                className="form-control form-control-solid"
                type="text"
                value={data.app_id}
                onChange={e => {
                  data.app_id = e.target.value || null
                  this.setState({data})
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-3 col-form-label">App Key{data.sub_merchant === false ? "*" : ""}</label>
            <div className="col-9">
              <input
                className="form-control form-control-solid"
                type="text"
                value={data.app_key}
                onChange={e => {
                  data.app_key = e.target.value || null
                  this.setState({data})
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-3 col-form-label">Merchant ID{data.sub_merchant === false ? "*" : ""}</label>
            <div className="col-9">
              <input
                className="form-control form-control-solid"
                type="text"
                value={data.merchant_id}
                onChange={e => {
                  data.merchant_id = e.target.value || null
                  this.setState({data})
                }}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>

          <button
            type="button"
            className="btn btn-outline-primary ml-3"
            onClick={() => this.props.onCancel()}
          >
            Close
          </button>

          <button
            type="button"
            disabled={loading}
            className="btn btn-primary ml-3"
            onClick={() => this._connect()}
          >
            Save
          </button>

        </Modal.Footer>
      </>
    )
  }

}
